/**
 * Phaser scene lifecycle event names as plain strings (identical to `Phaser.Scenes.Events.UPDATE /
 * SHUTDOWN / DESTROY`), so the simulation classes (ActorSystem, NpcScheduleRunner, Follower,
 * PlayerController, Actor) need no runtime Phaser import and can be unit-tested in Node against a fake
 * scene that only provides `events.on / once / off / emit`.
 */
export const SceneEvents = { UPDATE: 'update', SHUTDOWN: 'shutdown', DESTROY: 'destroy' } as const;
